import { Injectable } from '@angular/core';
import { select } from '@ngneat/elf';
import { reportsStateStore, ReportsStateProps, reportsInitialState } from './reports-state.store';
import { BaseStoreRepository } from '../base-store.repository';
import { DacDemandeGroup } from '@/types';
import { combineLatest, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReportsRepository extends BaseStoreRepository<ReportsStateProps> {
  constructor() {
    super(reportsStateStore.pipe(select(state => state)), reportsStateStore, reportsInitialState);
  }

  setReports(reports: DacDemandeGroup[]) {
    this.set('reports', reports);
  }

  getReports(): DacDemandeGroup[] {
    return this.get<DacDemandeGroup[]>('reports') || [];
  }

  setLoading(loading: boolean) {
    this.set('loading', loading);
  }

  getSelectedDacDetails(): Observable<any | undefined> {
    return combineLatest([
      this.getObservable<any[]>('availableDacs'),
      this.getNestedObservable<number>('createRequest', 'dacId'),
    ]).pipe(map(([dacs, dacId]) => dacs?.find((dac: any) => dac.dacId === dacId)));
  }
}
